import { ColorPicker, Space, Typography } from 'antd'
import { AggregationColor } from 'antd/es/color-picker/color'
import { useHistogramConfiguration } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { DrilldownPlotType } from 'features/drilldown/components/histogram/DrilldownHistogram'
import { DEFAULT_PLOT_TYPE } from 'features/drilldown/components/histogram/HistogramRenderer'
import { FC, useCallback, useMemo } from 'react'

const { Text } = Typography

const PLOT_TYPES_WITH_CONFIGURABLE_COLOR: ReadonlyArray<DrilldownPlotType> = [
  'bar',
]

export const HistoColorConfigView: FC = () => {
  const { plotType, color, setColor } = useHistogramConfiguration()
  const onColorChange = useCallback(
    (value: AggregationColor) => {
      setColor(value.toHexString())
    },
    [setColor]
  )

  const isColorConfigurable = useMemo(
    () =>
      PLOT_TYPES_WITH_CONFIGURABLE_COLOR.includes(
        plotType ?? DEFAULT_PLOT_TYPE
      ),
    [plotType]
  )

  return (
    <>
      {isColorConfigurable && (
        <Space align='center' size='small'>
          <Text strong>Color:</Text>
          <ColorPicker value={color} onChange={onColorChange} />
        </Space>
      )}
    </>
  )
}
